 import Vue from 'vue'

const api = Vue.prototype.$api

export default {
  getLanguages () {
    return api.get('/languages')
  },
  getProfLanguagesBySpecialty (specialtyId) {
    return api.get('/languages/GetProfLanguagesBySpecialty', { params: {specialtyId: specialtyId} })
  },
  getCenterLanguagesBySpecialty (specialtyId) {
    return api.get('/languages/GetCenterLanguagesBySpecialty', { params: {specialtyId: specialtyId} })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/LanguageRepository.js